
import Drop from "../../../assets/outline/Drop.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DropIcon({ className, dataTestid = "DropIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Drop data-testid={dataTestid} className={classes} {...rest} />
  );
}
